import React from 'react';
import { InstagramIcon, FacebookIcon, MailIcon, FlameIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-brown text-brand-cream py-12 border-t border-white/10" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center md:items-start text-center md:text-left" data-id="element-78">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-79">
            <div className="flex items-center gap-2 mb-4" data-id="element-80">
              <FlameIcon className="h-6 w-6 text-brand-gold" data-id="element-81" />
              <span className="font-serif text-2xl font-bold text-white" data-id="element-82">
                Velas Essenciais
              </span>
            </div>
            <p className="text-brand-cream/60 text-sm max-w-xs leading-relaxed" data-id="element-83">
              Transformando paixão por velas em negócios lucrativos e iluminando
              vidas através do empreendedorismo feminino.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col space-y-3" data-id="element-84">
            <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-85">
              Termos de Uso
            </a>
            <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-86">
              Política de Privacidade
            </a>
            <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-87">
              Contato e Suporte
            </a>
          </div>

          {/* Social */}
          <div className="flex flex-col items-center md:items-end" data-id="element-88">
            <h4 className="font-bold text-white mb-4 font-serif tracking-wide text-lg" data-id="element-89">
              Acompanhe
            </h4>
            <div className="flex gap-4" data-id="element-90">
              <a href="https://www.instagram.com/jbluzearoma" className="bg-white/5 p-3 rounded-full hover:bg-brand-gold hover:text-brand-brown transition-all border border-white/10" aria-label="Instagram" data-id="element-91">
                <InstagramIcon className="w-5 h-5" data-id="element-92" />
              </a>

              <a href="mailto:contato@velasessenciais.com.br" className="bg-white/5 p-3 rounded-full hover:bg-brand-gold hover:text-brand-brown transition-all border border-white/10" aria-label="Email" data-id="element-93">
                <MailIcon className="w-5 h-5" data-id="element-94" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-brand-cream/40 text-sm" data-id="element-95">
          <p data-id="element-96">
            &copy; {currentYear} Velas Essenciais. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>;
}